<template>
  <!-- need list headers  -->
  <div>
    <div class="hvh-flex wrap">
      <!-- put  -->
      <div class="col-12 col-lg-6 p-4">
        <Loader v-if="dxisLoading" />
        <HCPProfileHorizontalBarChart title="Diagnoses (Patient Count)" :data="dxData" label="Patients" nameField="name" valueField="count" v-else />
      </div>

      <div class="col-12 col-lg-6 p-4">
        <Loader v-if="rxisLoading" />
        <HCPProfileHorizontalBarChart title="Drugs (Script Count)" :data="rxData" label="Scripts" nameField="name" valueField="count" v-else />
      </div>
    </div>

    <div class="hvh-flex wrap">
      <div class="col-12 col-lg-4 p-4">
        <Loader v-if="isLoading" />
        <HCPProfileBarChart title="Age Distribution" :data="modelData.ageGroups" label="Age Group" nameField="name" valueField="value" v-else />
      </div>

      <div class="col-12 col-lg-4 p-4">
        <Loader v-if="isLoading" />
        <HCPProfileDonutChart v-else title="Gender Distribution" :data="modelData.gender" />
      </div>

      <div class="col-12 col-lg-4 p-4">
        <Loader v-if="isLoading" />
        <HCPProfileBarChart v-else title="Insurance Distribution" :data="modelData.insurance" nameField="name" valueField="value" />
      </div>
    </div>
  </div>
</template> 


<script>
import axios from '../../axios';
import HCPProfileBarChart from './charts/HCPProfileBarChart.vue';
import HCPProfileDonutChart from './charts/HCPProfileDonutChart.vue';
import HCPProfileHorizontalBarChart from './charts/HCPProfileHorizontalBarChart.vue';
import { errorDebug } from '../../libraries/common'

export default {
  components: { HCPProfileBarChart, HCPProfileDonutChart, HCPProfileHorizontalBarChart },
  props: ['npi', 'runID', 'cohortId'],
  data() {
    return {
      isLoading: true,
      dxisLoading: true,
      rxisLoading: true,

      modelData: null,
      dxData: null,
      rxData: null,
    };
  },
  methods: {
    getData() {
      var { runId, npi } = this.$route.params;
      this.isLoading = true;
      // set the modeldata to the claims stuff here 
      axios.get(`/HCPProfiles/${runId}/PatientDemoCharacteristics/${npi}`)
        .then(response => {
          this.modelData = response.data;
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);


      // this.isLoading = true;
      this.dxisLoading = true;
      axios.get(`/HCPProfiles/${runId}/PatientClaimsCharacteristics/${npi}/dx`)
        .then(response => this.dxData = response.data)
        .catch(errorDebug)
        .then(() => this.dxisLoading = false);

      this.rxisLoading = true;
      axios.get(`/HCPProfiles/${runId}/PatientClaimsCharacteristics/${npi}/rx`)
        .then(response => this.rxData = response.data)
        .catch(errorDebug)
        .then(() => this.rxisLoading = false)
    },
  },
  mounted() {
    this.getData()
  },
}

</script>
